import React from 'react';
import icons from "assets/images/Icon_grp.svg";

const Icon = ({id, width = 20, height = 24, color = 'black', viewBox, stroke=''}) => (
  <svg
    width={width}
    height={height}
    fill={color}
    stroke={stroke}
    viewBox={viewBox || `0 0 ${width} ${height}`}
  >
    {/*<use xlinkHref={`${icons}#${id}`} />*/}
    <use href={`${icons}#${id}`} />
  </svg>
);

export default Icon;

